import { COHORT_STATUS_COMPLETED } from "@pathwright/web/src/modules/group/constants"
import MENTOR_GROUP_FRAGMENT from "@pathwright/web/src/modules/mentor-group/graphql/mentor-group-fragment"
import { getApolloClient } from "@pathwright/web/src/modules/pathwright/PathwrightClient"
import SCHOOL_GROUP_SUBSCRIPTION_FRAGMENT from "@pathwright/web/src/modules/subscription/graphql/school-group-subscription-fragment"
import { getIsSubscriptionExpired } from "@pathwright/web/src/modules/subscription/utils"
import { flattenEdges } from "@pathwright/web/src/modules/utils/apollo"
import { getResourceSlugId } from "@pathwright/web/src/modules/utils/urls"
import gql from "graphql-tag"
import get from "lodash/get"
import { getURLParameter } from "../../lib/core/api/urls"

// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const Resource = require("library/models/resource").default
const RegistrationCollection =
  require("library/models/registration-collection").default
const Offering = require("library/models/offering").default
const OfferingCollection = require("library/models/offering-collection").default
const {
  ENROLLMENT_ROLE_OBSERVER,
  ENROLLMENT_ROLE_STUDENT,
  ENROLLMENT_ROLE_FACILITATOR
} = require("invitation/constants")
const { getPaginationData } = require("lib/core/api/resource-loader")

const OFFERING_ROUTE_RE = /\/library\/[0-9a-zA-Z-_]+\/\d+\//

// Wrapper for store actions to return the action's promise
const actionPromiseExposer =
  (fn) =>
  (...args) =>
    fn(...args).promise

class ResourceStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    ;`\
Container for the user's relationship with a resource
All resource controllers and views should use this data
as the "source of truth" for their data.\
` // will overlay screen if expired subscription

    this.prototype.resources = {
      resource: {
        model: Resource
      },
      offering: {
        model: Offering,
        collection: OfferingCollection
      },
      registration: {
        collection: RegistrationCollection
      }
    }

    this.prototype.storeTriggerHandlers = {
      resourceAdmin: {
        "resource:updated"(resource) {
          if (resource.id === __guard__(this.get("resource"), (x) => x.id)) {
            return this.action.refreshResource()
          }
        },
        "resource:deleted"(resource_id) {
          if (resource_id === __guard__(this.get("resource"), (x) => x.id)) {
            // clear store after route change, Not Before!, otherwise everything breaks
            return this.listenToOnce(
              this.getStore("navigation"),
              "change:url",
              this.action.clearSelectedResource
            )
          }
        }
      },
      authorAdmin: {
        "author:deleted"(deletedAuthor) {
          const resourceAuthors = __guard__(this.get("resource"), (x) =>
            x.get("authors")
          )
          if (
            resourceAuthors &&
            resourceAuthors.find((author) => author.id === deletedAuthor.id)
          ) {
            return this.action.refreshResource()
          }
        }
      },
      groupAdmin: {
        "offering:updated"(offering) {
          if (offering.id === __guard__(this.get("offering"), (x) => x.id)) {
            this.get("offering").set(offering.toJSON())
            if (this.get("offerings").get(offering.id)) {
              this.get("offerings").get(offering.id).set(offering.toJSON())
            }
            return this.triggerChange("change:offering")
          }
        },
        "offering:created"(offering) {
          const resource = this.get("resource")
          const offerings = this.get("offerings")
          // Maybe a better solution available, but the resource has been "updated" in a way
          // since the num_offerings has changed at least
          // TODO: something similar for "offering:deleted"?
          if (resource != null) {
            if (offerings != null) {
              // Trying to avoid reloading offerings if we can
              resource.set({
                num_offerings: (resource.get("num_offerings") || 0) + 1
              })
              offerings.add(offering, { at: 1 })
              if (!this.get("offering")) {
                this.action.selectOfferingByID(offering.id)
              }
              return this.triggerChange("change:offerings")
            } else {
              let forceReload, route
              const { slug } = this.getState().resource
              const { section } = this.getState()
              return this.action.selectResourceBySlug(
                slug,
                offering.id,
                section,
                (route = false),
                (forceReload = true)
              )
            }
          }
        },
        "offering:deleted"(offering) {
          return this.action.handleDeletedOffering(offering)
        }
      },
      auth: {
        "user:signed:in"() {
          if (!App.getStore("register").getState().state) {
            // need to make sure this sign in didn't happen because of a sign-up
            return this.action.reload(true)
          }
        },
        "user:signed:out"() {
          return this.action.reload(false)
        }
      },
      register: {
        "registration:created"({ offering }) {
          return this.action._onRegistrationCreated(offering)
        }
      },
      member: {
        "removed:member"() {
          const { offering } = this.getState()
          if (offering) {
            this.get("offering").set({
              seats_filled: offering.seats_filled - 1
            })
            return this.triggerChange("change:offering")
          }
        }
      }
    }

    this.prototype.storeTriggers = {
      "offering:changed"() {
        return this.get("offering")
      },
      "resource:reloaded"() {
        return this.getState()
      }
    }

    this.prototype.actions = {
      refreshResource() {
        return this.resource.resource.load(
          { id: this.get("resource").id },
          false,
          true // ignoring cache
        )
      },

      setResource(resource) {
        return this._mutate({ resource })
      },

      selectResource(resource, offering, section) {
        if (offering == null) {
          offering = null
        }
        const changes = {}
        if (resource.id !== __guard__(this.get("resource"), (x) => x.id)) {
          changes.resource = resource
        }

        if (
          offering != null &&
          offering.id !== __guard__(this.get("offering"), (x1) => x1.id)
        ) {
          if (offering.get("resource_id") === resource.id) {
            changes.offering = offering
          }
        }

        if (!_.isEmpty(changes)) {
          this._mutate(changes)
        }
      },

      setRegistration(registration) {
        // This should allow views to reload properly on registered
        return this._mutate({ registration })
      },

      async selectOfferingByID(
        offeringID,
        forceReload = false,
        ignoreCache = false
      ) {
        offeringID = parseInt(offeringID)
        const off = this.get("offering")
        const shouldFetch =
          !off || (off && off.id !== offeringID) || forceReload || ignoreCache
        if (shouldFetch) {
          // Try to find it in the resource
          const resource = this.get("resource")
          const offerings = this.get("offerings")
          let offering = null

          if (offerings && !forceReload && !ignoreCache) {
            offering = offerings.find(function (o) {
              return o.id === offeringID
            })
          }

          if (!offering || forceReload || ignoreCache) {
            const invite_token = getURLParameter("ic") || null
            const params = {
              resource_id: resource.id,
              id: offeringID,
              invite_token
            }
            return await this.resource.offering.load(
              params,
              forceReload,
              ignoreCache
            )
          } else {
            this._mutate({ offering })
            return offering
          }
        } else {
          return this.get("offering")
        }
      },

      selectResourceBySlug(slug, offeringID, section, route, forceReload) {
        if (route == null) {
          route = false
        }
        if (forceReload == null) {
          forceReload = false
        }
        let { resource, offering } = this.getState()

        if (
          resource &&
          resource.slug !== slug &&
          resource.id !== getResourceSlugId(slug)
        ) {
          this.action.clearSelectedResource()
        }

        if (
          offering != null &&
          offeringID != null &&
          (offering != null ? offering.id : undefined) !== parseInt(offeringID)
        ) {
          this.action.clearSelectedOffering(false)
        }

        this._mutate({ section })

        return this.resource.resource
          .load({ slug }, forceReload)
          .then((fetchedResource) => {
            resource = fetchedResource
            this.action.selectResource(resource)
            if (offeringID) {
              return this.action
                .selectOfferingByID(offeringID)
                .promise.then(
                  actionPromiseExposer(this.action.checkOfferingPermissions)
                )
                .catch(actionPromiseExposer(this.action.ensureOffering))
                .then((offering) => (forceReload = false))
            } else {
              return (forceReload = false)
            }
          })
          .then((forceReload) => this.action.loadOfferings(forceReload).promise)
          .then(() => {
            if (route) {
              this.action.setURL()
            }
            return null
          })
          .then(() => {
            if (this.getStore("auth").request.isAuthenticated()) {
              return this.action.loadUserRegistrations().promise
            }
          })
          .then(actionPromiseExposer(this.action.ensureOffering))
          .then(this.action.updateNavigationTitle)
          .catch((err) => {
            console.error(err)
            const { offering, offering_error } = this.getState()
            const { is_authenticated } = window.App.getStore("auth").getState()

            // Slightly handle permissions
            if (!offering || offering_error) {
              let nextLocation =
                window.App.getStore("navigation").request.getNextLocation()
              if (is_authenticated) {
                // You can't view this resource. Tap your heals, Dorathy
                nextLocation =
                  window.App.getStore("navigation").request.getBackTo()
              }

              // show popupError
              App.getStore("layout").action.showIn("popupAlert", null, {
                error: offering_error || `Unable to load resource.`,
                onClear: () =>
                  App.getStore("layout").action.closeIn("popupAlert")
              })
              window.App.navigate(nextLocation)
            }
          })
      },

      ensureOffering() {
        const { offerings, resource } = this.getState()
        let { offering } = this.getState()
        const permissions = window.App.getStore("school").getState()
        const { session } = window.App.getStore("auth").getState()

        if (!offering) {
          if (offerings && offerings.length) {
            offering = new Offering(offerings[0])
          } else if (
            // Staff
            (permissions &&
              (permissions.user_is_school_editor ||
                permissions.user_is_school_admin)) ||
            // Members, if resource can be viewed by members
            (session &&
              session.school_membership &&
              !!session.school_membership.id &&
              resource.visibility_level_override == 10) ||
            // Anyone, if resource can be viewed by anyone
            resource.visibility_level_override == 15
          ) {
            offering = new Offering({
              id: resource.curriculum_offering,
              permissions: {},
              name: resource.name
            })
          }

          if (offering) {
            this._mutate({ offering })
          } else {
            throw new Error(
              "You do not have permissions to view this offering."
            )
          }
        }
      },

      loadOfferings(forceReload = false, ignoreCache = false) {
        const resource = this.get("resource")
        return this.resource.offering.list(
          { resource: resource.id, page_size: 100 },
          forceReload,
          ignoreCache
        )
      },

      loadMoreOfferings() {
        // TODO: bake this into loaders (if we really need it going forward)
        const key = "offerings"
        return new Promise(
          function (resolve, reject) {
            const collection = this.get(key)
            this._mutate({ [`${key}_loading_more`]: true })
            return collection
              .next()
              .then(() => {
                const pagination_data = getPaginationData(collection)
                this._mutate({
                  [`${key}_loading_more`]: false,
                  [`${key}_pagination`]: pagination_data
                })
                this.triggerChange(`change:${key}`)
                return resolve()
              })
              .fail(reject)
          }.bind(this)
        )
      },

      selectResourceSection(section) {
        return this._mutate({ section })
      },

      reload(signedIn) {
        let offeringID
        const { resource, offering, section } = this.getState()
        if (resource == null) {
          return
        }

        const navStore = this.getStore("navigation")

        // need to clear then reload
        if (signedIn) {
          offeringID = offering != null ? offering.id : undefined
        } else {
          offeringID = null
        }

        // clear the resource cache
        this.resource.resource.clearCache()
        this.resource.offering.clearCache()
        this.resource.registration.clearCache()

        window.App.stores.requestStore("path").reset()
        window.App.stores.requestStore("step").reset()
        this.action.clearSelectedResource()
        // Only reload if user potentially has perms to access resource.
        if (signedIn || resource.highest_visibility_level >= 15) {
          let forceReload, route
          return this.action
            .selectResourceBySlug(
              resource.slug,
              offeringID,
              section,
              (route = false),
              (forceReload = true)
            )
            .promise.then(() => {
              if (this.get("offering")) {
                return this.storeTrigger("resource:reloaded")
              }
            })
        } else {
          navStore.action.goHome()
        }
      },

      checkOfferingPermissions() {
        const { offering, offering_error } = this.getState()
        if (offering_error && [401, 403].includes(offering_error.status)) {
          throw new Error("You do not have permissions to view this offering.")
        }
      },

      clearSelectedOffering(clearCache = true) {
        window.App.stores.requestStore("path").reset()
        window.App.stores.requestStore("pathAdmin").reset()
        window.App.stores.requestStore("register").reset()
        window.App.stores.requestStore("discussion").reset()
        if (clearCache) {
          this.resource.offering.clearCache()
          this._mutate(this.resource.offering.initialState)
        }
      },

      clearSelectedResource() {
        //if @get("resource")
        // TODO: make this event based?
        this.action.clearSelectedOffering()
        this.action.clearSelectedRegistration()
        this.reset()
      },

      clearSelectedRegistration() {
        this.resource.registration.clearCache()
        return this._mutate(this.resource.registration.initialState)
      },

      loadUserRegistrations(forceReload = false, ignoreCache = false) {
        const params = { resource_id: this.get("resource").id }
        return this.resource.registration
          .list(params, forceReload, ignoreCache)
          .then(() => this.action.selectRegistration().promise)
      },

      // Selects a registration and ensures we have the offering matching that registration
      selectRegistration() {
        return new Promise(
          function (resolve, reject) {
            let registration
            const updates = { registration: null }
            const { offering, offerings, registrations } = this.getState()

            if (registrations && registrations.length) {
              // If offering then we may find a matching registration
              registration = registrations.find(
                (r) => r.offering.id === get(offering, "id")
              )
              // Don't select a new offering based on registration if we're we're an admin
              if (
                !this.request.permissions("can_edit_resource") &&
                !OFFERING_ROUTE_RE.test(window.location.pathname)
              ) {
                if (!registration) {
                  // Either no offering or no registration matching the offering
                  registration = registrations.find((r) =>
                    offerings.find((o) => r.offering.id === o.id)
                  )
                }
                if (!registration) {
                  // No registration matching any offering, need to load the offering
                  return resolve(
                    this.action
                      .selectOfferingByID(registrations[0].offering.id)
                      .promise.then((offering) => {
                        this._mutate({ offering })
                        return this.action.selectRegistration()
                      })
                  )
                }
              }
            }
            if (registration) {
              updates.registration = this.get("registrations").get(
                registration.id
              )
              // The selected offering didn't match any registration
              if (
                registration.offering.id !==
                  (offering != null ? offering.id : undefined) &&
                !__guard__(
                  this.request.permissions(),
                  (x2) => x2.can_edit_resource
                )
              ) {
                updates.offering = this.get("offerings").get(
                  registration.offering.id
                )
              }
            } else if (!offering) {
              updates.offering = this.get("offerings").first()
            }

            this._mutate(updates)
            return resolve(registration)
          }.bind(this)
        )
      },

      handleDeletedOffering(offering) {
        const selected = this.get("offering")
        const offerings = this.get("offerings")

        // Nothing to update
        if (!offerings || !selected) {
          return
        }

        // Update offerings if they contain the deleted offering.
        if (offerings.get(offering.id)) {
          this.resource.offering.clearCache()
          offerings.remove(offering.id)
          this.triggerChange("change:offerings")
        }

        // Clear selected offering if it was deleted.
        if (selected.id === offering.id) {
          return this.action.clearSelectedOffering()
        }
      },

      updateNavigationTitle() {
        let { id, slug, name: title } = this.getState().resource
        if (!title) {
          title = this.getStore("school").getState().school.name
        }
        return this.getStore("navigation").action.setURLTitle(title)
      },

      async _onRegistrationCreated(offering) {
        const forceReload = false
        const ignoreCache = true
        const queryOptions = [forceReload, ignoreCache]
        // Ignoring cache - mainly to update the staff shown above the path,
        // and ingoreCache doesn't clear the resource keys causing UI to flash (as opposed to forceReload which does)
        await this.action.loadOfferings(...queryOptions).promise
        await this.action.selectOfferingByID(offering.id, ...queryOptions).promise // prettier-ignore
        await this.action.loadUserRegistrations(...queryOptions).promise
      }
    }

    this.prototype.requests = {
      discussionEnabled() {
        const { offering, resource } = this.getState()
        return (
          (resource != null ? resource.discussion_enabled : undefined) &&
          (offering != null ? offering.discussion_enabled : undefined)
        )
      },

      canRegisterForOffering() {
        const { offering, resource } = this.getState()
        if (!offering || !resource) {
          return false
        }
        if (offering.id === resource.curriculum_offering) {
          return false
        }
        return true
      },

      getInviteURLs() {
        const { offering, registration } = this.getState()
        if (
          (registration != null ? registration.invite_urls : undefined) != null
        ) {
          return registration.invite_urls
        } else if (
          (offering != null ? offering.invite_urls : undefined) != null
        ) {
          return offering.invite_urls
        }
        return null
      },

      toRegisterLink() {
        const { resource, offerings } = this.getState()

        let toRegister = ""

        if (resource) {
          toRegister = {
            pathname: `/library/${resource.slug}/register/`,
            state: { modal: true }
          }

          if (
            (offerings != null ? offerings.length : undefined) === 1 &&
            !resource.license_offerings.length
          ) {
            toRegister.pathname += `${offerings[0].id}/`
          }
        }

        return toRegister
      },

      getRegistrationForOffering(offeringID) {
        const { registrations } = this.getState()
        return _.find(registrations, (r) => r.offering.id === offeringID)
      },

      curriculumOffering() {
        return __guard__(this.get("offerings"), (x) =>
          x.find((offering) => offering.get("is_curriculum") === true)
        )
      },

      getOfferingByID(offeringID) {
        if (
          __guard__(this.get("offering"), (x) => x.id) === parseInt(offeringID)
        ) {
          return this.get("offering")
        }
        if (__guard__(this.get("offerings"), (x1) => x1.length)) {
          return this.get("offerings").get(offeringID)
        }
        return null
      },

      permissions(key) {
        let { resource, offering, registration } = this.getState()
        // It's possible the user may have a source ohort registration.
        // In that case, let's also base perms off that registration.
        let sourceRegistration = this.request.getRegistrationForOffering(
          resource?.curriculum_offering
        )

        let perms = null
        // returns the permissions for the current resource/offering
        if (offering) {
          perms = {
            ...offering.permissions
          }
        }

        function assignPermsFromRegistration(registration) {
          if (registration) {
            if (perms == null) {
              perms = {}
            }
            perms = _.extend(
              perms,
              { can_access: true },
              registration.permissions
            )
            perms.can_invite_observer =
              perms.can_invite_observer ||
              registration.invite_urls.observer != null
            perms.can_invite_student =
              perms.can_invite_student ||
              registration.invite_urls.student != null
            perms.can_invite_moderator =
              perms.can_invite_moderator ||
              registration.invite_urls.moderator != null
            perms.can_invite_teacher =
              perms.can_invite_teacher ||
              registration.invite_urls.teacher != null
            perms.can_facilitate =
              perms.can_facilitate ||
              registration.role >= ENROLLMENT_ROLE_FACILITATOR
            if (offering) {
              perms.can_view_analytics =
                perms.can_view_analytics ||
                (() => {
                  switch (offering.analytics_visibility) {
                    case 5:
                      return registration.role >= ENROLLMENT_ROLE_FACILITATOR
                    case 10:
                      return registration.role >= ENROLLMENT_ROLE_STUDENT
                    case 15:
                      return true
                    default:
                      return false
                  }
                })()
            }
          }
        }

        // In order of level of permission, assign perms based on registration
        // then source registration.
        assignPermsFromRegistration(registration)
        assignPermsFromRegistration(sourceRegistration)

        // TEMPORARY FIX
        // can_edit_path is set incorrectly if admin enrolled as moderator
        // setting it to match perms.can_edit as fallback
        if (perms != null) {
          // and perms.can_edit_path is undefined
          perms.can_edit_path = perms.can_edit =
            perms.can_edit || perms.can_edit_path
        }

        if (perms != null && perms.can_edit_resource == null) {
          perms.can_edit_resource = perms.can_edit
        }

        if (perms != null && perms.can_edit_offering == null) {
          perms.can_edit_offering = perms.can_edit
        }

        // remove certain perms from user if the offering is "completed" and the use does not have can_edit_path perms
        if (
          perms &&
          !perms.can_edit_path &&
          offering &&
          offering.status === COHORT_STATUS_COMPLETED
        ) {
          perms.can_invite_observer = false
          perms.can_invite_student = false
          perms.can_invite_moderator = false
          perms.can_invite_teacher = false
          perms.can_facilitate = false
          perms.can_participate = false
          perms.can_register = false
        }

        if (key) {
          if (perms) {
            return perms[key] || false
          }
          return false
        }

        return perms
      },

      // returns list of subscription plan IDs included in the cohort that the user has access to
      includedInUserSubscription(offering) {
        const { subscription, subscribe_state } =
          this.getStore("subscribe").getState()
        if (
          offering &&
          (subscription != null ? subscription.subscription : undefined) !=
            null &&
          subscribe_state === "active"
        ) {
          return _.intersection(offering.include_in_subscription_plans, [
            subscription.school_plan.id
          ])
        }
        return []
      },

      // returns list of group subscription plan IDs (in the form of Stripe produts) included in the cohort that the user has access to
      async includedInUserGroupSubscription(offering) {
        const _currentAuthState = App.getStore("auth").get("is_authenticated")
        // force json data
        offering = offering && offering.toJSON ? offering.toJSON() : offering

        if (
          offering &&
          offering.include_with_products &&
          offering.include_with_products.length
        ) {
          // NOTE: schoolGroupSubscriptions are scoped to user's mentor group memberships
          const SCHOOL_GROUP_SUBSCRIPTIONS_QUERY = gql`
            query UserGroupSubscriptionsQuery {
              schoolGroupSubscriptions(first: 10) {
                edges {
                  node {
                    ...SchoolGroupSubscription
                    community_group {
                      ...MentorGroup
                      user_membership {
                        id
                        access_revoked_time
                      }
                    }
                  }
                }
              }
            }
            ${SCHOOL_GROUP_SUBSCRIPTION_FRAGMENT}
            ${MENTOR_GROUP_FRAGMENT}
          `

          const client = getApolloClient(window.school.id)

          const userSchoolGroupSubscriptionsQuery = await client.query({
            query: SCHOOL_GROUP_SUBSCRIPTIONS_QUERY,
            fetchPolicy:
              this._prevAuthState !== _currentAuthState
                ? "network-only"
                : "cache-first"
          })

          const groupSubscriptions = flattenEdges(
            get(
              userSchoolGroupSubscriptionsQuery,
              "data.schoolGroupSubscriptions"
            ) || []
          )

          if (groupSubscriptions.length) {
            const activeGroupSubscriptions = groupSubscriptions.filter(
              (sub) =>
                !getIsSubscriptionExpired(sub.subscription) &&
                sub.community_group.user_membership &&
                !sub.community_group.user_membership.access_revoked_time
            )

            const activeGroupSubscriptionIds = activeGroupSubscriptions.map(
              (sub) => sub.price.product.id
            )

            return _.intersection(
              offering.include_with_products,
              activeGroupSubscriptionIds
            ).map(
              // HACK ALERT: need to map back to the group subscription ID for registration purposes
              (planId) =>
                activeGroupSubscriptions.find(
                  (sub) => sub.price.product.id === planId
                ).id
            )
          }
        }

        this._prevAuthState = _currentAuthState

        return []
      },

      seatsAvailable(offering, invitation) {
        if (!offering) {
          return null
        }
        if (
          offering.resource_license &&
          offering.resource_license.ignore_seat_count
        ) {
          return -1
        }
        if (!offering.resource_license) {
          if (invitation && invitation.role === ENROLLMENT_ROLE_OBSERVER) {
            // observers don't count towards the offering's seats filled
            return -1
          }
          return offering.seats_available
        }
        return Math.max(
          offering.resource_license.seat_count -
            offering.resource_license.seats_filled,
          0
        )
      },

      getRegistrationContext() {
        let regContext = null
        const registration = this.get("registration")
        if (registration) {
          regContext = registration.toJSON()
        }
        return regContext
      },

      resourceIs(type) {
        const resource_type = __guard__(this.get("resource"), (x) =>
          x.get("resource_type")
        )
        switch (resource_type) {
          case 10:
            return type === "course"
          case 20:
            return type === "lesson"
        }
      },

      resourceUrl() {
        const { resource, offering, section } = this.getState()
        let url = `/library/${resource.slug}/`
        if (offering) {
          url = `${url}${offering.id}/`
        }
        url = `${url}${section}/`
        return url
      }
    }
  }

  defaults() {
    return {
      resource: null, // The resource being viewed
      offerings: null, // The offerings attached to the resource
      offering: null, // The offering being viewed
      registration: null, // The user's registration if any
      section: "about", // Which tab is the user looking at?
      url: null // the url matching the current state
    }
  }

  computeURLForState() {
    ;`\
Returns a URL matching the user's existing state\
`
    const { resource, offering, section } = this.getState()
    let url = `/library/${resource.slug}/`
    if (offering) {
      url = `${url}${offering.id}/`
    }
    url = `${url}${section}/`
    return url
  }

  bootstrapStore() {
    if (!window.bootstrappedData) {
      return
    }
    const data = {}
    const { resource, offering } = window.bootstrappedData
    if (resource) {
      data.resource = new Resource(bootstrappedData.resource)
    }
    if (offering) {
      data.offering = new Offering(bootstrappedData.offering)
    }
    if (!_.isEmpty(data)) {
      return this._mutate(data)
    }
  }
}
ResourceStore.initClass()

export default window.App.stores.registerStore("resource", ResourceStore)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
